export default function MinusCircle({ className, backgroundColor }) {
    return (
      <svg className={className} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_1874_25272)">
          <circle cx="8" cy="8" r="8" fill={backgroundColor} />
          <path d="M4 8H12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
        </g>
        <defs>
          <clipPath id="clip0_1874_25272">
            <rect width="16" height="16" fill="currentColor"/>
          </clipPath>
        </defs>
      </svg>
    )
}
